import { X, Check } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const PAIRS = [
  {
    them: "Treats AI rollouts and team alignment as entirely separate initiatives.",
    us: "Integrates process engineering and human behavioral alignment simultaneously.",
  },
  {
    them: "Leaves employees to guess how to handle automated exceptions and errors.",
    us: "Engineers seamless exception-handling protocols directly in-app via WalkMe.",
  },
  {
    them: "Focuses strictly on software integration.",
    us: "Uses business analysis to tie Human-in-the-Loop performance directly to hard KPIs.",
  },
];

export default function Advantage() {
  return (
    <section
      id="advantage"
      data-testid="advantage-section"
      className="relative py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <SectionHeader
          index="04"
          label="The Advantage"
          testid="advantage-heading"
          title={
            <>
              What makes the handoff <span className="italic text-[#EB5E28]">work</span>.
            </>
          }
        />
        <Reveal className="mt-14" delay={0.1}>
          <div className="overflow-hidden rounded-2xl border border-[#E2E8F0] shadow-sm" data-testid="advantage-comparison-table">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="border-b border-[#E2E8F0] bg-[#F1F5F9] px-6 py-5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#626D7D] md:border-r lg:px-8">
                Traditional Tech Implementation
              </div>
              <div className="border-b border-[#E2E8F0] bg-[#0F141A] px-6 py-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white lg:px-8">
                The Thom Kriner LLC Methodology
              </div>
              {PAIRS.map((p, i) => (
                <div key={i} className="contents">
                  <div className="flex items-start gap-3 border-b border-[#E2E8F0] bg-white px-6 py-6 md:border-r lg:px-8">
                    <X className="mt-0.5 h-4 w-4 shrink-0 text-[#8B95A5]" />
                    <p className="text-sm leading-relaxed text-[#626D7D] lg:text-[0.95rem]">{p.them}</p>
                  </div>
                  <div className="flex items-start gap-3 border-b border-[#E2E8F0] bg-white px-6 py-6 lg:px-8">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#EB5E28]" strokeWidth={2.5} />
                    <p className="text-sm leading-relaxed text-[#0F141A] lg:text-[0.95rem]">{p.us}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
